/**
 * BottleAnimation — champagne bottle 🍾 with a cork-pop + confetti spray.
 * Bottle tilts + shakes, a gold cork shoots out top-right, and 10 confetti
 * squares fan out from the neck. Best played at 220px on the burst layer.
 */
export default function BottleAnimation({ size = 140 }) {
  const confetti = [
    { dx: "60px",  dy: "-70px", color: "#fbbf24", delay: "0.35s", rot: "540deg" },
    { dx: "40px",  dy: "-90px", color: "#f43f5e", delay: "0.4s",  rot: "-420deg" },
    { dx: "80px",  dy: "-40px", color: "#22c55e", delay: "0.45s", rot: "480deg" },
    { dx: "70px",  dy: "-80px", color: "#3b82f6", delay: "0.42s", rot: "-380deg" },
    { dx: "50px",  dy: "-100px",color: "#a855f7", delay: "0.5s",  rot: "560deg" },
    { dx: "90px",  dy: "-30px", color: "#ec4899", delay: "0.47s", rot: "-460deg" },
    { dx: "30px",  dy: "-110px",color: "#f59e0b", delay: "0.55s", rot: "400deg" },
    { dx: "20px",  dy: "-60px", color: "#f97316", delay: "0.38s", rot: "-500deg" },
    { dx: "100px", dy: "-60px", color: "#06b6d4", delay: "0.52s", rot: "440deg" },
    { dx: "-10px", dy: "-90px", color: "#facc15", delay: "0.6s",  rot: "-360deg" },
  ];
  return (
    <div
      className="pointer-events-none"
      style={{ width: size, height: size, position: "relative", overflow: "hidden" }}
    >
      <style>{`
        @keyframes bottle-shake {
          0%   { transform: translate(0, 20%) rotate(0deg) scale(0.5); opacity: 0; }
          15%  { transform: translate(0, -6px) rotate(-8deg) scale(1.4); opacity: 1; }
          22%  { transform: translate(-4px, -4px) rotate(6deg) scale(1.3); opacity: 1; }
          30%  { transform: translate(4px, -4px) rotate(-6deg) scale(1.35); opacity: 1; }
          40%  { transform: translate(0, -12px) rotate(-15deg) scale(1.4); opacity: 1; filter: drop-shadow(0 0 34px rgba(251,191,36,0.9)); }
          70%  { transform: translate(0, -8px) rotate(-14deg) scale(1.3); opacity: 1; filter: drop-shadow(0 0 28px rgba(251,191,36,0.7)); }
          100% { transform: translate(0, 0) rotate(0deg) scale(1); opacity: 0; filter: drop-shadow(0 0 0 rgba(251,191,36,0)); }
        }
        @keyframes bottle-cork {
          0%   { transform: translate(0, 0) rotate(0deg) scale(0.4); opacity: 0; }
          38%  { transform: translate(0, 0) rotate(0deg) scale(0.4); opacity: 0; }
          42%  { transform: translate(20px, -20px) rotate(45deg) scale(1); opacity: 1; }
          100% { transform: translate(110px, -140px) rotate(720deg) scale(0.6); opacity: 0; }
        }
        @keyframes bottle-confetti {
          0%   { transform: translate(0, 0) rotate(0deg) scale(0.3); opacity: 0; }
          40%  { opacity: 0; }
          50%  { opacity: 1; transform: translate(calc(var(--dx) * 0.3), calc(var(--dy) * 0.3)) rotate(calc(var(--rot) * 0.3)) scale(0.9); }
          100% { transform: translate(var(--dx, 0), var(--dy, 0)) rotate(var(--rot, 360deg)) scale(1); opacity: 0; }
        }
      `}</style>

      {/* Confetti spray from the bottle neck */}
      {confetti.map((c, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            left: "45%",
            top: "35%",
            width: 9,
            height: 13,
            background: c.color,
            borderRadius: 2,
            transform: "translate(-50%, -50%)",
            animation: `bottle-confetti 1.4s ease-out ${c.delay} forwards`,
            "--dx": c.dx,
            "--dy": c.dy,
            "--rot": c.rot,
            boxShadow: `0 0 6px ${c.color}`,
          }}
        />
      ))}
      {/* The cork itself — small tan circle flying up-right */}
      <div
        style={{
          position: "absolute",
          left: "45%",
          top: "38%",
          width: 12,
          height: 12,
          borderRadius: "50%",
          background: "linear-gradient(135deg, #c2a878, #92714a)",
          boxShadow: "0 0 10px #fbbf24, inset -2px -2px 3px rgba(0,0,0,0.4)",
          transform: "translate(-50%, -50%)",
          animation: "bottle-cork 1.4s ease-out forwards",
        }}
      />
      {/* Bottle emoji */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          fontSize: size * 0.7,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: "bottle-shake 1.4s cubic-bezier(.22,1,.36,1) forwards",
        }}
      >
        🍾
      </div>
    </div>
  );
}
